import { z } from 'zod';
/**
 * Zod-схема ответа эндпоинта `GET /health`.
 *
 * Источник истины для типа `HealthResponse` — реиспользуется в:
 * - `apps/api/src/modules/health/health.controller.ts` — валидация исходящего payload.
 * - `apps/web/src/App.tsx` — валидация входящего ответа.
 */
export const healthResponseSchema = z.object({
    /** Литерал — индикатор успешного ответа. */
    status: z.literal('ok'),
    /** Количество секунд с момента старта процесса API. */
    uptimeSeconds: z.number().nonnegative(),
    /** ISO-8601 timestamp ответа сервера. */
    timestamp: z.string().datetime(),
    /** Версия сервиса (продуктовая, из `APP_VERSION` пакета shared). */
    version: z.string(),
    /** Тег сборки — git-sha релиза (env `APP_VERSION`), если задан. */
    build: z.string().optional(),
});
/**
 * Ответ эндпоинта `GET /ready`.
 *
 * Сигнализирует, готов ли инстанс обслуживать запросы. Если зависимости
 * (например, PostgreSQL) недоступны — checks содержит подробности, status='down'.
 */
export const readyResponseSchema = z.object({
    status: z.enum(['ready', 'down']),
    /** Результаты индивидуальных проверок зависимостей. */
    checks: z.record(z.string(), z.object({
        ok: z.boolean(),
        error: z.string().optional(),
        durationMs: z.number().optional(),
    })),
});
export * from './extra-service';
export * from './client-profile';
export * from './auth';
export * from './reference-books';
export * from './orders';
export * from './agreements';
export * from './service-catalog';
export * from './poruchenie-template';
export * from './reference-data';
export * from './quotes';
export * from './shipments';
export * from './payments';
export * from './audit-view';
export * from './manager-clients';
export * from './expeditor-profile';
export * from './admin-staff';
export * from './mailer-settings';
export * from './auth-reset';
export * from './integrations';
export * from './notifications';
export * from './payment-demands';
export * from './delivery-legs';
export * from './pdf-viz';
//# sourceMappingURL=index.js.map